module.exports = __webpack_public_path__ + "img/04_feature_m.dc013a8c.svg";